import React, { Component } from "react";
import "./style.scss";
import { Helmet } from "react-helmet";

class Projets extends Component {
  render() {
    return (
      <div className="page Projets">
        <Helmet>
          <title>Tanguy HELLER | Projets</title>
        </Helmet>

        <h1>Projets</h1>

        <div className="section interactable">
          <a href="https://playdeviant.com/">
            <div className="presentoir-wrapper">
              <div className="date">2021</div>
              <div className="presentoir">
                <img src="/images/vgc_small.png" alt="vgc-logo" />
                <div className="text-section">
                  <h2>VGC - Console de salon virtuelle</h2>
                  <p>
                    Projet réalisé avec un camarade à la suite de notre contrat
                    d'alternance.
                  </p>
                  <p>
                    Disponible à l'adresse :{" "}
                    <a href="https://playdeviant.com/">
                      https://playdeviant.com/
                    </a>
                  </p>
                  <p>
                    L'idée est de créer une console de salon virtuelle, qui
                    permette de synchroniser les téléphones de chacun au site et
                    lancer des jeux communautaires entre amis.
                  </p>
                  <p>
                    Plus de détails dans la section{" "}
                    <a href="/experiences">mes expériences</a> qui concerne ce
                    projet.
                  </p>
                </div>
              </div>
            </div>
          </a>
        </div>

        <br />

        <div className="section">
          <div className="presentoir-wrapper">
            <div className="date">2021</div>
            <div className="presentoir">
              <a href="/">
                <img src="/images/favicon.png" alt="site-logo" />
              </a>
              <div className="text-section">
                <h2>Site perso</h2>
                <p>
                  Le site sur lequel vous êtes actuellement en train de naviguer
                  ! Il a été développé avec le framework REACT.
                  <br />
                  Retour à l'accueil : <a href="/">Home</a>
                </p>
              </div>
            </div>
          </div>
        </div>

        <br />

        <div className="section interactable">
          <a href="https://lolcanyoufindthemall.firebaseapp.com/">
            <div className="presentoir-wrapper">
              <div className="date">2021</div>
              <div className="presentoir">
                <a href="https://lolcanyoufindthemall.firebaseapp.com/">
                  <img src="/images/lol-logo.png" alt="lol-logo" />
                </a>
                <div className="text-section">
                  <h2>Can you find them all LOL edition</h2>
                  <p>
                    Petit quizz sur le jeu League of Legends réalisé avec Unity
                    (c#) et hébergé avec Firebase.
                    <br />
                    Disponible à l'adresse :{" "}
                    <a href="https://lolcanyoufindthemall.firebaseapp.com/">
                      lolcanyoufindthemall.firebaseapp.com
                    </a>
                  </p>
                </div>
              </div>
            </div>
          </a>
        </div>

        <br />

        <div className="section interactable">
          <a href="https://tower-of-ascension.firebaseapp.com/">
            <div className="presentoir-wrapper">
              <div className="date">2018</div>
              <div className="presentoir">
                <a href="https://tower-of-ascension.firebaseapp.com/">
                  <img src="/images/toa.jpg" alt="toa-logo" />
                </a>
                <div className="text-section">
                  <h2>Tower Of Ascension - rogue-like sur navigateur</h2>
                  <p>
                    Réalisé sur RPGMaker MV (Javascript) et hébergé sur
                    Firebase.
                    <br />
                    Disponible à l'adresse :{" "}
                    <a href="https://tower-of-ascension.firebaseapp.com/">
                      tower-of-ascension.firebaseapp.com
                    </a>
                  </p>
                </div>
              </div>
            </div>
          </a>
        </div>

      </div>
    );
  }
}

export default Projets;
